import { Flex, Loader, Text } from '@mantine/core';
import * as React from 'react';

import { markdownPlainPreview } from '@/utils/markdownPlainPreview';

import s from './DocumentNotesList.module.scss';

/** Защита от чрезмерно длинного буфера в DOM при реальном стриме. */
const STREAM_PREVIEW_MAX_CHARS = 120_000;

type DocumentAiSummaryGeneratingRowProps = {
  streamPreview: string;
};

const DocumentAiSummaryGeneratingRow: React.FC<DocumentAiSummaryGeneratingRowProps> = ({ streamPreview }) => {
  const hasStream = streamPreview.trim().length > 0;
  const scrollRef = React.useRef<HTMLDivElement>(null);

  const displayText = React.useMemo(() => {
    const clipped =
      streamPreview.length > STREAM_PREVIEW_MAX_CHARS ? streamPreview.slice(-STREAM_PREVIEW_MAX_CHARS) : streamPreview;

    return markdownPlainPreview(clipped, STREAM_PREVIEW_MAX_CHARS);
  }, [streamPreview]);

  React.useLayoutEffect(() => {
    const el = scrollRef.current;

    if (!el || !hasStream) {
      return;
    }

    const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    const nearBottom = distanceFromBottom < 72;

    if (nearBottom) {
      el.scrollTop = el.scrollHeight;
    }
  }, [displayText, hasStream]);

  return (
    <div className={s['root__ai-generating']}>
      <Flex align="center" gap="sm" wrap="nowrap">
        <Loader type="dots" size="sm" color="indigo" />
        <Text size="sm" fw={600}>
          {hasStream ? 'Формирую саммари по заметкам…' : 'Запускаю генерацию саммари по заметкам…'}
        </Text>
      </Flex>
      {hasStream && (
        <div ref={scrollRef} className={s['root__ai-stream-scroll']}>
          <Text size="sm" c="dimmed" className={s['root__ai-stream']} component="div">
            {displayText}
          </Text>
        </div>
      )}
    </div>
  );
};

export default React.memo(DocumentAiSummaryGeneratingRow);
